import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../services/api";
import { useTranslation } from "../i18n";
import "./Login.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch {
      setError(t("auth.somethingWrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-gradient" />
      </div>

      <div className="login-container" style={{ justifyContent: "center" }}>
        <div className="login-card">
          <div className="login-header">
            <Link to="/" className="login-brand">
              <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
            </Link>

            {sent ? (
              <>
                <h1 className="login-title">{t("auth.resetYourPassword")}</h1>
                <p
                  className="login-subtitle"
                  dangerouslySetInnerHTML={{ __html: t("auth.resetEmailSent", { email }) }}
                />
                <div style={{ marginTop: 24 }}>
                  <Link to="/login" className="link-btn">{t("auth.backToLogin")}</Link>
                </div>
              </>
            ) : (
              <>
                <h1 className="login-title">{t("auth.resetYourPassword")}</h1>
                <p className="login-subtitle">{t("auth.resetDesc")}</p>
              </>
            )}
          </div>

          {!sent && (
            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="login-error">{error}</div>}

              <div className="form-group">
                <label className="form-label">{t("login.email")}</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="form-input"
                  required
                />
              </div>

              <button type="submit" className="btn-primary btn-full" disabled={loading}>
                {loading ? <span className="btn-spinner" /> : t("auth.sendResetLink")}
              </button>

              <div className="login-switch">
                <Link to="/login" className="link-btn">{t("auth.backToLogin")}</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
